import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, map, Observable, throwError } from 'rxjs';
import { AppointmentTime, Site } from './site/site';
import { AuthService } from '../auth.service';
import { VitaError } from '../vita-error';

@Injectable({
  providedIn: 'root'
})
export class ManagementService {

  constructor(private http: HttpClient, private auth: AuthService) { }
  getSites(): Observable<Site[]> {
    // const baseHeaders = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');

    return this.http.get<Site[]>("/api/sites")
    .pipe(map(response =>{
      return response;
    }));
  }
  updateAppointmentTime(appointmentTimeId: number, numberOfAppointments: number): Observable<Object> {
    const baseHeaders = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');
    const data = `numberOfAppointments=${numberOfAppointments}`
    return this.http.post(`/api/appointmentTimes/${appointmentTimeId}`, data, {headers: baseHeaders})
    .pipe(map(response => {
      return response
    }))
  }
  addAppointmentTime(siteId: number, date: string, scheduledTime: string, appointmentTypeId: string, numberOfAppointments: number, is_hidden: boolean): Observable<Object> {
    const baseHeaders = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');
    const data = `scheduledTime=${date+' '+scheduledTime}&appointmentTypeId=${appointmentTypeId}&numberOfAppointments=${numberOfAppointments}&is_hidden=${is_hidden}`
    return this.http.post(`/api/sites/${siteId}/appointmentTimes`, data, {headers: baseHeaders})
    .pipe(map(response => {
      return response
    }), catchError((error: HttpErrorResponse) => {
            let errorMessage = '';
            const vitaError = error.error as VitaError
            if (vitaError != null) {
              errorMessage = vitaError.message
            } else if (error.error instanceof ErrorEvent) {
              // Client-side error
              errorMessage = `An error occurred: ${error.error.message}`;
            } else {
              // Server-side error
              errorMessage = `Server returned code: ${error.status}, error message: ${error.message}`;
            }
            return throwError(() => new Error(errorMessage)); // Re-throw for further handling
          }
    ))
  }
  getAppointmentTimesForSite(siteId: number): Observable<AppointmentTime[]> {
    return this.http.get<AppointmentTimesResult>(`/api/sites/${siteId}/appointmentTimes`)
    .pipe(map(response =>{
      return response.data
    }));
  }
  getSiteInformation(siteId: number): Observable<Site> {
    return this.http.get<Site>(`/api/sites/${siteId}`)
    .pipe(map(response =>{
      return response;
    }));
  }
}


interface SiteInformationResult {
  success: boolean
  site: Site
}
interface AppointmentTimesResult {
  data: AppointmentTime[]
}